// Export all types
export type * from './types.js';

// Export main context and provider
export { DrawerStackProvider, DrawerStackContext } from './context.js';

// Export utility hooks
export {
  useDrawerStack,
  useDrawerStackRequired,
  useDrawerLevel,
  useDrawerZIndex,
  useCanNest,
  useShouldReplace
} from './hooks.js';

// Export router for advanced usage
export { DrawerRouter } from './router.js';

// Export reducer for testing
export { drawerStackReducer } from './reducer.js';

// Export debugging utilities
export { DrawerDebugger, safeGet, safeObjectKeys } from './debug.js';
